export type AssetVisibility = "all" | "holder";
export type ProtocolStatus = "pending" | "approved" | "rejected";

export interface Branch {
  id: string;
  name: string;
}

export interface Asset {
  id: string;
  number: number;
  name: string;
  description: string;
  branch: string | null;
  branch_name: string | null;
  visibility: AssetVisibility;
  visibility_display: string;
  assigned_to: string | null;
  assigned_to_name: string | null;
  assigned_at: string | null;
  is_available: boolean;
  created_by: string | null;
  created_by_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface ManagedFileBrief {
  id: string;
  original_filename: string;
  content_type: string;
  size_bytes: number;
  url: string | null;
}

export interface HandoverProtocolItem {
  id: string;
  number: number;
  name: string;
}

export interface HandoverProtocol {
  id: string;
  number: number;
  employee: string;
  employee_name: string | null;
  items: string[];
  items_detail: HandoverProtocolItem[];
  status: ProtocolStatus;
  status_display: string;
  signed_document: string | null;
  signed_document_detail: ManagedFileBrief | null;
  note: string;
  reviewed_by: string | null;
  reviewed_by_name: string | null;
  reviewed_at: string | null;
  review_comment: string;
  created_at: string;
  updated_at: string;
}

export const VISIBILITY_LABELS: Record<AssetVisibility, string> = {
  all: "Widoczny dla wszystkich",
  holder: "Widoczny tylko dla użytkującego",
};

export const PROTOCOL_STATUS_LABELS: Record<ProtocolStatus, string> = {
  pending: "Do akceptacji",
  approved: "Zaakceptowany",
  rejected: "Odrzucony",
};

export const PROTOCOL_STATUS_COLORS: Record<ProtocolStatus, "yellow" | "green" | "red"> = {
  pending: "yellow",
  approved: "green",
  rejected: "red",
};
